import { render, staticRenderFns } from "./PointeCohorts.vue?vue&type=template&id=1252db69&scoped=true"
import script from "./PointeCohorts.vue?vue&type=script&lang=js"
export * from "./PointeCohorts.vue?vue&type=script&lang=js"
import style0 from "./PointeCohorts.vue?vue&type=style&index=0&id=1252db69&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1252db69",
  null
  
)

export default component.exports